import _ from "lodash-es";
import TimeUtil from "@/lib/common/time-util";

const key = "examc:exam:video:default:device";
declare const MediaRecorder: any;

export default class Video {
  static readonly videoMediaTypes = [
    "video/mp4",
    "video/mpeg",
    "video/webm",
    "video/3gpp",
    "video/3gp2",
    "video/webm;codecs=h264",
    "video/webm;codecs=vp8",
    "video/webm;codecs=vp9",
    "video/webm;codecs=daala"
  ];

  static currentDeviceId = "";
  static currentDeviceLock = false;

  static getUserMedia(
    constraints?: MediaStreamConstraints
  ): Promise<MediaStream> {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      return navigator.mediaDevices.getUserMedia(constraints);
    } else if (_.get(navigator, "webkitGetUserMedia")) {
      // @ts-ignore
      return _.get(navigator, "webkitGetUserMedia")(constraints);
    } else if (_.get(navigator, "mozGetUserMedia")) {
      // @ts-ignore
      return _.get(navigator, "mozGetUserMedia")(constraints);
    } else if (_.get(navigator, "getUserMedia")) {
      // @ts-ignore
      return _.get(navigator, "getUserMedia")(constraints);
    }
    return Promise.reject(new Error("当前浏览器不支持录像"));
  }

  static getDefaultDeviceId(): string {
    const deviceId = localStorage.getItem(key);
    return deviceId ? deviceId : "";
  }

  static setDefaultDeviceId(deviceId: string) {
    localStorage.setItem(key, deviceId);
  }

  static checkSupport(): boolean {
    let support = false;
    // @ts-ignore
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      support = true;
    } else if (_.get(navigator, "webkitGetUserMedia")) {
      support = true;
    } else if (_.get(navigator, "mozGetUserMedia")) {
      support = true;
    }
    return support;
  }

  static checkRecorder() {
    try {
      return MediaRecorder ? true : false;
    } catch (e) {
      return false;
    }
  }

  static supportedVideoMineTypes(): string[] {
    if (!MediaRecorder || !_.isFunction(MediaRecorder.isTypeSupported)) {
      return [];
    }
    return this.videoMediaTypes.filter(type => {
      return MediaRecorder.isTypeSupported(type);
    });
  }

  static enumerateDevices() {
    return this.getUserMedia({
      video: true
    })
      .then(stream => {
        const tracks = stream.getTracks();
        for (let i = 0; i < tracks.length; i++) {
          tracks[i].stop();
        }
        return navigator.mediaDevices.enumerateDevices();
      })
      .then(devices => {
        return devices.filter(device => {
          return device.kind == "videoinput";
        });
      });
  }

  static currentDevice(): Promise<string> {
    if (!_.isEmpty(this.currentDeviceId)) {
      return Promise.resolve(this.currentDeviceId);
    }
    if (this.currentDeviceLock) {
      return TimeUtil.sleep(1000).then(() => {
        return this.currentDevice();
      });
    }
    this.currentDeviceLock = true;
    return this.enumerateDevices()
      .then(devices => {
        if (_.isEmpty(devices)) {
          return Promise.reject(new Error("未找到摄像头设备"));
        }
        for (const device of devices) {
          if (device.deviceId === Video.getDefaultDeviceId()) {
            this.currentDeviceId = device.deviceId;
            return device.deviceId;
          }
        }
        Video.setDefaultDeviceId(devices[0].deviceId);
        this.currentDeviceId = devices[0].deviceId;
        return devices[0].deviceId;
      })
      .finally(() => {
        this.currentDeviceLock = false;
      });
  }

  static openCamera(deviceId?: string, audio?: boolean) {
    return this.getUserMedia({
      video: deviceId
        ? {
            advanced: [{ deviceId: deviceId }]
          }
        : {},
      audio: audio ? audio : false
    });
  }

  static formatErrorMessage(e: DOMException): string {
    let errorMessage = "";
    switch (e.name) {
      case "AbortError":
        errorMessage = "设备终止";
        break;
      case "NotAllowedError":
        errorMessage = "未授权获取摄像头权限，请授权后重新刷新页面";
        break;
      case "NotFoundError":
        errorMessage = "设备未找到，请检查您的摄像头设备";
        break;
      case "NotReadableError":
        errorMessage = "设备异常，无法获取视频数据";
        break;
      case "OverConstrainedError":
        errorMessage = "指定的要求无法被设备满足";
        break;
      case "SecurityError":
        errorMessage = "设备媒体被禁止";
        break;
      default:
        errorMessage = "未知错误";
    }
    return errorMessage;
  }
}
